import React from 'react';
import { Icon } from './Icon.js';
export const IconFolderOpen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20.5 21L21.5 12L2.5 12L3.5 21L20.5 21Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M20 8V6H12.5L9.5 3H4V8", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconFolderOpen.js.map